import { Inject, Injectable, RendererFactory2 } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { ListResponseWrapper, ItemResponseWrapper, ApiErrorResponse } from '../http.types';
import { throwError } from 'rxjs';

@Injectable()
export class HttpUtilsService {
  constructor(
    private rendererFactory: RendererFactory2,
    private http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  public simplifyErrorResponse$(errorResponse: ApiErrorResponse) { return throwError(errorResponse.error.error); }

  public entityWrapperResponseMapper = <T>(json: ItemResponseWrapper<T>): T => json.data;

  public listWrapperResponseMapper = <T>(json: ListResponseWrapper<T>): T[] => json.data;

  public download(url: string, fileName?: string): void {
    const renderer = this.rendererFactory.createRenderer(null, null)
    this.http
      .get(url, { responseType: 'blob', observe: 'response' })
      .subscribe((response: HttpResponse<Blob>) => {
        if (!fileName) {
          const regexp = /attachment;.*filename=(.+)$/i;
          const res = regexp.exec(response.headers.get('content-disposition') || '');
          fileName = res?.[1] || `file-${Math.round(Math.random() * 1000)}`;
        }

        const binaryData = [response.body || ''];
        const linkElement = renderer.createElement('a');
        const dataUrl = URL.createObjectURL(new Blob(binaryData, { type: response.body?.type }));

        renderer.setAttribute(linkElement, 'href', dataUrl);
        renderer.setAttribute(linkElement, 'style', 'height:0; visibility: hidden; width:0');
        renderer.setAttribute(linkElement, 'download', fileName);
        renderer.appendChild(this.document.body, linkElement);
        linkElement.click();
      });
  }
}
